import Component from './post_detail.vue'
export default Component
